import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyRouterModule } from '../../route.module';
import { epicObs } from '../../store';

import { PowerBiReportComponent } from './power-bi-report.component';
import { PowerBiReportRoutes } from './power-bi-report.route';
import { powerBiEpics } from './power-bi.epic';
import { setModuleInjector } from './power-bi.metadata';
import { PowerBiService } from './power-bi.service';

@NgModule({
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsLazyRouterModule.forChild(PowerBiReportRoutes),
    ],
    declarations: [PowerBiReportComponent],
    providers: [PowerBiService],
})
export class CmpsPowerBiReportModule {
    constructor(private readonly _injector: Injector) {
        setModuleInjector(_injector);
        powerBiEpics.forEach((e) => epicObs.next(e));
    }
}
